export default {
	buildings: {
		buildingCount: 'Number of buildings',
		doorwayCount: 'Number of doorways',
		assignTeamMember: 'Assign team member',
		editTeamMember: 'Edit team member',
		removeTeamMember: 'Remove team member',
		confirmRemoveTeamMember:
			'Do you want to remove the team member assignment from this building?',
		teamMemberRemovedSuccess: 'Team member successfully removed',
		teamMemberRemoveError: 'Failed to remove team member. Please try again.',
		setAsTitleImage: 'Set as title image',
		addImage: 'Add image',
		deleteImage: 'Delete image',
		sendAccessData: 'Send access data',
		general: 'General',
		uploadImage: 'Upload Image',
		// Property Manager Assignment
		propertyManager: 'Property Manager',
		propertyManagerModalTitle: 'Assign Property Manager',
		selectedBuildingsCount:
			'{count} building selected | {count} buildings selected',
		selectPropertyManager: 'Select Property Manager',
		assignPropertyManager: 'Assign',
		removePropertyManager: 'Remove',
		markForExportCheckbox: 'Also release for Aaremo',
		markForExportCheckboxHint:
			'When enabled, buildings will automatically be released for export to Aaremo',
		assignPropertyManagerTitle: 'Assign Property Manager',
		removePropertyManagerTitle: 'Remove Property Manager',
		assignPropertyManagerDescription:
			'You are about to assign "{name}" as property manager for {count} building. | You are about to assign "{name}" as property manager for {count} buildings.',
		removePropertyManagerDescription:
			'You are about to remove the property manager from {count} building. | You are about to remove the property manager from {count} buildings.',
		assignPropertyManagerDisclaimer:
			'Assigning a property manager will update all selected buildings. The property manager will handle requests and processing. If a building is released for Aaremo, it will be synchronized.',
		removePropertyManagerDisclaimer:
			'⚠️ WARNING: Removing the property manager prevents buildings from being released for Aaremo. Currently released buildings will have their release revoked automatically.',
		confirmAssign: 'Confirm & Assign',
		confirmRemove: 'Confirm & Remove',
		propertyManagerUpdateError:
			'Failed to update property manager. Please try again.',
		confirmAssignPropertyManager:
			'Do you want to assign "{name}" as property manager for {count} building? | Do you want to assign "{name}" as property manager for {count} buildings?',
		confirmRemovePropertyManager:
			'Do you want to remove the property manager from {count} building? | Do you want to remove the property manager from {count} buildings?',
		// Export
		export: 'Export',
		markForExport: 'Enable for Aaremo',
		unmarkForExport: 'Remove from Aaremo',
		proposeForExport: 'Enable for Aaremo',
		confirmMarkForExport:
			'Do you want to release {count} building for Aaremo? | Do you want to release {count} buildings for Aaremo?',
		confirmUnmarkForExport:
			'Do you want to remove {count} building from Aaremo? | Do you want to remove {count} buildings from Aaremo?',
		confirmMarkSingleForExport:
			'Do you want to release "{name}" for export to Aaremo? The building will then be transferred from Karthago to Aaremo.',
		confirmUnmarkSingleFromExport:
			'Do you want to remove "{name}" from Aaremo? The building will no longer be transferred from Karthago to Aaremo.',
		thisBuilding: 'this building',
		// Export Status Modal
		markForExportTitle: 'Release Building for Aaremo',
		unmarkFromExportTitle: 'Remove Building from Aaremo',
		buildingLabel: 'Building',
		markForExportDescription:
			'You are about to release this building for export to Aaremo. Its data will then be transferred from the Karthago property management system to Aaremo.',
		unmarkFromExportDescription:
			"You are about to revoke this building's Aaremo release. No further data will be transferred from Karthago to Aaremo.",
		whatHappens: 'What happens next?',
		whatHappensMarkItem1:
			'The building will be flagged as "released for Aaremo"',
		whatHappensMarkItem2:
			"All of this building's data, including address, units, and property manager information, will be transferred to Aaremo",
		whatHappensMarkItem3:
			'Future changes to this building will automatically be transferred from Karthago to Aaremo',
		whatHappensMarkItem4:
			'The synchronization process may take a few minutes to complete',
		whatHappensUnmarkItem1: "The building's Aaremo release will be revoked",
		whatHappensUnmarkItem2:
			'No further changes to this building will be transferred from Karthago to Aaremo',
		whatHappensUnmarkItem3:
			'All related data (units, persons, etc.) will be deleted from Aaremo during the next synchronization',
		disclaimer: 'Important Note',
		markForExportDisclaimer:
			'Please ensure all building data is complete and accurate before releasing it for Aaremo. Incomplete or incorrect data may cause synchronization errors.',
		unmarkFromExportDisclaimer:
			'⚠️ WARNING: Removing a building from Aaremo will DELETE all related data (building, units, persons, contracts, etc.) from Aaremo during the next synchronization. The data in Karthago will remain intact, but will no longer be available in the mobile platform. This action cannot be undone automatically.',
		hint: 'Tip',
		exportStatusHint:
			'You can change the Aaremo release at any time from the building actions menu.',
		// Bulk Export Modal (BuildingExport.vue)
		exportModalTitle: 'Aaremo Release',
		selectedBuildingsExportMessage:
			'{count} building selected | {count} buildings selected',
		exportModalDescription:
			'Release the selected buildings for Aaremo or revoke their release. You can refine your selection below.',
		currentExportStatus: 'Current Release',
		proposed: 'Released for Aaremo',
		notProposed: 'Not Released',
		propertyManagerRequired: 'Property Manager Required',
		withPropertyManager: 'With Property Manager',
		withoutPropertyManager: 'Without Property Manager',
		propertyManagerStatus: 'Property Manager Status',
		onlyBuildingsWithPMWillBeMarked:
			'Only buildings with a property manager will be released',
		markBuildingsForExportTitle: 'Release Buildings for Aaremo',
		unmarkBuildingsForExportTitle: 'Remove Buildings from Aaremo',
		markBuildingsForExportDescription:
			'You are about to release {count} building for export to Aaremo. | You are about to release {count} buildings for export to Aaremo.',
		unmarkBuildingsForExportDescription:
			'You are about to revoke the Aaremo release of {count} building. | You are about to revoke the Aaremo release of {count} buildings.',
		markBuildingsForExportDisclaimer:
			'Please ensure the data of the selected buildings is complete and accurate before releasing them for Aaremo. Buildings without a property manager will be skipped automatically.',
		unmarkBuildingsForExportDisclaimer:
			'⚠️ WARNING: Removing the selected buildings from Aaremo will DELETE all related data (building, units, persons, contracts, etc.) from Aaremo during the next synchronization. The data in Karthago will remain intact, but will no longer be available in the mobile platform.',
		whatHappensMarkBuildingsItem1:
			'The selected buildings will be flagged as "released for Aaremo"',
		whatHappensMarkBuildingsItem2:
			'All data of these buildings will be transferred from Karthago to Aaremo',
		whatHappensMarkBuildingsItem3:
			'Future changes to these buildings will automatically be transferred from Karthago to Aaremo',
		whatHappensUnmarkBuildingsItem1:
			"The selected buildings' Aaremo release will be revoked",
		whatHappensUnmarkBuildingsItem2:
			'No further changes to these buildings will be transferred from Karthago to Aaremo',
		whatHappensUnmarkBuildingsItem3:
			'All related data of these buildings will be deleted from Aaremo during next sync',
		noValidBuildingsForExport:
			'No valid buildings for release (all buildings are missing a property manager)',
		exportSuccessWithSkipped:
			'{updated} building(s) updated successfully. {skipped} skipped (missing property manager).',
		// Security Verification
		securityVerification: 'Security Verification',
		enterPassword: 'Enter your password',
		invalidPassword: 'Invalid password. Please try again.',
		disclaimerConfirmation:
			'I have read and understood the implications of this action',
		confirmMark: 'Confirm & Release',
		confirmUnmark: 'Confirm & Remove',
		markedForExportSuccess: 'Building successfully released for Aaremo',
		unmarkedFromExportSuccess: 'Building successfully removed from Aaremo',
		exportStatusUpdateError: 'Failed to update the release. Please try again.',
		// Error messages
		errorMissingPropertyManager:
			'Cannot release {count} building (property manager missing) | Cannot release {count} buildings (property manager missing)',
		exportRequiresPropertyManager:
			'Cannot release building without a property manager. Please assign a property manager first.',
		partialExportSuccess:
			'{success} building(s) updated successfully. {failed} failed because property manager is missing.',
		// Status indicators
		exportMarked: 'Released for Aaremo',
		notProposedForExport: 'Not Released',
		missingPropertyManager: 'Property Manager Missing',
	},
}
